"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 *
 * @param {String} date - date from order confirmation page i.e 2020-05-19T01:24:17
 *
 * @returns desired format, dd/mm/yyyy
 *
 * @improvement - in the future this function can be updated to return date for given format pattern.
 *
 */
var FormatCreationDate = function FormatCreationDate(date) {
  var dateObject = new Date(date);
  var month = dateObject.getMonth() + 1;
  var day = dateObject.getDate();

  if (month < 10) {
    month = '0' + month;
  }

  if (day < 10) {
    day = '0' + day;
  }

  return "".concat(day, "/").concat(month, "/").concat(dateObject.getFullYear());
};

var _default = FormatCreationDate;
exports["default"] = _default;